import { GetDefaultTeamMembersResponse, GetTeamMembers, TeamMember, TeamMembersPrivateNotes } from '../typings';
import { get, makeRequestDeduped } from '../../../../infra/rest';
import { WabaIntegrationMemberProvider } from '../../../../shared/typings/waba';

export const getTeamMembers = async (
  teamId?: string,
  provider?: WabaIntegrationMemberProvider
): Promise<TeamMember[]> => {
  const params = new URLSearchParams({ memberStatus: 'joined' });
  if (provider) {
    params.set('provider', provider);
  }
  const url = `/v1/organization/team/${teamId ?? 'DEFAULT_TEAM'}?${params.toString()}`;

  const { teamMembers } = await makeRequestDeduped<GetTeamMembers>(url, {}, true);

  return teamMembers;
};

export const getTeamMembersPrivateNotes = async (): Promise<TeamMembersPrivateNotes> => {
  const { teamMembers, deletedTeamMembers } = await get<GetDefaultTeamMembersResponse>(
    `/v1/organization/team-members`,
    {},
    true
  );

  return {
    allTeamMembers: [...teamMembers, ...deletedTeamMembers],
    activeTeamMembers: teamMembers,
  };
};
